import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArtworkCard } from "../components/ArtworkCard";
import { Seo } from "../components/Seo";

const CATEGORIES = ["Tous", "Abstrait", "Expressionnisme", "Moderne", "Peinture"];

export default function Gallery() {
  const [artworks, setArtworks] = useState([]);
  const [artists, setArtists] = useState([]);
  const [category, setCategory] = useState("Tous");
  const [artist, setArtist] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/artists").then((r) => setArtists(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (category !== "Tous") params.category = category;
    if (artist) params.artist = artist;
    api
      .get("/artworks", { params })
      .then((res) => setArtworks(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [category, artist]);

  return (
    <div className="pt-32 pb-24 max-w-7xl mx-auto px-6 lg:px-10 min-h-screen" data-testid="gallery-page">
      <Seo title="Galerie — Tableaux à vendre" description="Découvrez et achetez des tableaux uniques d'artistes handicapés : art abstrait, expressionniste et moderne. Paiement sécurisé, soutien direct aux artistes." path="/galerie" />
      <p className="text-xs uppercase tracking-[0.3em] text-[#60a5fa] mb-3">La galerie</p>
      <h1 className="font-display text-5xl md:text-6xl text-white tracking-tight mb-10">Toutes les œuvres</h1>

      {/* Category filter */}
      <div className="flex flex-wrap gap-3 mb-5">
        {CATEGORIES.map((c) => (
          <button
            key={c}
            data-testid={`filter-${c.toLowerCase()}`}
            onClick={() => setCategory(c)}
            className={`px-5 py-2 text-sm tracking-wide border transition-all ${
              category === c ? "bg-white text-black border-white" : "border-white/15 text-zinc-400 hover:text-white hover:border-white/40"
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      {/* Artist filter */}
      <div className="flex flex-wrap items-center gap-3 mb-14">
        <span className="text-zinc-500 text-xs uppercase tracking-widest mr-1">Artiste :</span>
        <button
          data-testid="artist-filter-all"
          onClick={() => setArtist("")}
          className={`px-4 py-1.5 text-sm border transition-all ${
            artist === "" ? "bg-[#2563EB] text-white border-[#2563EB]" : "border-white/15 text-zinc-400 hover:text-white"
          }`}
        >
          Tous
        </button>
        {artists.map((a) => (
          <button
            key={a.slug}
            data-testid={`artist-filter-${a.slug}`}
            onClick={() => setArtist(a.name)}
            className={`px-4 py-1.5 text-sm border transition-all ${
              artist === a.name ? "bg-[#2563EB] text-white border-[#2563EB]" : "border-white/15 text-zinc-400 hover:text-white"
            }`}
          >
            {a.name}
          </button>
        ))}
      </div>

      {artist && (
        <div className="mb-10">
          <Link to={`/artiste/${artists.find((a) => a.name === artist)?.slug || ""}`} className="text-[#60a5fa] text-sm hover:underline" data-testid="see-artist-universe">
            → Découvrir l'univers de {artist}
          </Link>
        </div>
      )}

      {loading ? (
        <p className="text-zinc-500">Chargement…</p>
      ) : artworks.length === 0 ? (
        <p className="text-zinc-500" data-testid="gallery-empty">Aucune œuvre pour cette sélection.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
          {artworks.map((a, i) => (
            <ArtworkCard key={a.id} artwork={a} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
